// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"27":"f5378c92","522":"93c34dd9","594":"75e6754c"}[chunkId] + ".css";
};